export const TEST_IDS = {
  rate: 'co-rate-card-rate',
  margin: 'co-rate-card-margin',
  listRate: 'co-rate-card-list-rate',
  repTarget: 'co-rate-card-rep-target',
  shipperRate: 'co-rate-card-shipper-rate',
  percentToMarket: 'co-rate-card-percent-to-market',
  carrierRateHistory: 'co-rate-card-carrier-rate-history',
}
